module.exports = __webpack_public_path__ + "static/img/index_bg_2.c4b940f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topImg/index_bg_2.jpg
// module id = yqmj
// module chunks = 9